export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_03.fa01d9b7.jpg";